import { defineClassNames } from '../../../utils/defineClassNames';

export const classes = defineClassNames('accordion-item', {
  root: {
    variants: {
      skin: ['standard', 'light', 'neutral'],
      size: ['xxTiny', 'xTiny', 'tiny', 'small', 'medium', 'large'],
      horizontalPadding: [
        'none',
        'xxTiny',
        'xTiny',
        'tiny',
        'small',
        'medium',
        'large',
      ],
      contentPadding: ['none'],
      titleSize: ['medium', 'small'],
      transitionSpeed: ['slow', 'medium', 'fast'],
    },
    states: ['open', 'disabled', 'hideShadow', 'last', 'caretWithLabel'],
  },
  header: {},
  iconsContainer: {},
  affix: {},
  titleWrapper: {},
  title: {},
  subtitle: {},
  panel: {},
  content: {},
  caret: {},
  caretButton: {},
});
